import { Dropdown, IconButton, IDropdownOption, mergeStyleSets } from "@fluentui/react";
import * as React from "react";
import { FunctionComponent } from "react";

interface Props {
  onChange?: (event: React.FormEvent<HTMLDivElement>, option?: IDropdownOption<any>, index?: number) => void;
  placeholder: string;
  selectedKey?: string | number | string[] | number[];
  selectedKeys?: string[] | number[];
  options: IDropdownOption<any>[];
  multiSelect?: boolean;
  onClearClick?: () => void;
}

const FilterDropDown: FunctionComponent<Props> = (props: Props) => {
  const { onChange, placeholder, selectedKey, options, selectedKeys, multiSelect, onClearClick } = props;

  const classNames = mergeStyleSets({
    dropdownStyles: {
      padding: 6,
      display: "flex",
      borderBottom: "1px solid #9B9B9B",
      borderRadius: "6px 6px 0 0",
      backgroundColor: "#F6F6F6",
      margin: 8,
    },
  });

  return (
    <div className={classNames.dropdownStyles}>
      <div style={{ flex: 4, padding: 6 }}>
        <Dropdown
          multiSelect={multiSelect}
          selectedKey={selectedKey ?? []}
          selectedKeys={selectedKeys ?? []}
          onChange={onChange}
          label={placeholder}
          options={options}
          styles={{
            title: {
              border: 0,
              backgroundColor: "#F6F6F6",
            },
          }}
        />
      </div>
      <div style={{ flex: 1, margin: "auto", textAlign: "center", paddingTop: 24 }}>
        <IconButton
          iconProps={{ iconName: "RemoveFilter", style: { fontSize: 24, color: "#AEAEAE" } }}
          onClick={onClearClick}
        ></IconButton>
      </div>
    </div>
  );
};

export default FilterDropDown;
